import http from "./http";

export default {
  create(data) {
    return http().post(`/v1/launch_control`, data);
  },
  update(launchControlId, data) {
    return http().put(`/v1/launch_control/${launchControlId}/update`, data);
  },
  updateCustomFields(launchControlId, data) {
    return http().put(`/v1/launch_control/${launchControlId}/update_custom_fields`, data);
  },
  delete(launchControlId) {
    return http().delete(`/v1/launch_control/${launchControlId}`);
  },
}
